import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Drawer } from '@shared/abstraction/drawer/drawer';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DrawerManagerService {
  private readonly translateService = inject(TranslateService);

  private drawerTrigger: Subject<Drawer> = new Subject();
  closeDrawer: Subject<void> = new Subject();

  get trigger(): Subject<Drawer> {
    return this.drawerTrigger;
  }

  open(setting: Drawer): void {
    setting.title = this.translateService.instant(setting.title);

    if (setting.primaryButton && setting.primaryButton.label) {
      setting.primaryButton.label = this.translateService.instant(
        setting.primaryButton.label
      );
    }

    if (setting.secondaryButton && setting.secondaryButton.label) {
      setting.secondaryButton.label = this.translateService.instant(
        setting.secondaryButton.label
      );
    }

    this.drawerTrigger.next(setting);
  }

  close(): void {
    this.closeDrawer.next();
  }
}
